import {
  useEffect,
  type MutableRefObject,
  type RefObject,
} from "preact/compat";

export const useIntersectionTracker = (
  {
    targetRef,
    root,
    threshold,
  }: {
    targetRef: MutableRefObject<RefObject<HTMLLIElement>[]>;
    root: HTMLElement | null;
    threshold: number;
  },
  callback: (idx: number) => void,
): void => {
  useEffect(() => {
    const onIntersectionObserved = (entries: IntersectionObserverEntry[]) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting && entry.intersectionRatio >= threshold) {
          const intersectingIndex = targetRef.current.findIndex(
            (target) => target.current?.outerHTML === entry.target.outerHTML,
          );
          callback(intersectingIndex);
        }
      });
    };

    const observer = new IntersectionObserver(onIntersectionObserved, {
      root: root,
      threshold: threshold,
    });

    targetRef.current.forEach((item) => {
      observer.observe(item.current!);
    });

    return () => observer.disconnect();
  }, []);
};
